module.exports = __webpack_public_path__ + "img/happiness_neutral.fd026ede.png";